export default function getResource(label, vars = []) {
    const resources = {
        userLabelText: `You must be ${vars[0]} to access this product.`,
        signIn: 'Sign in',
        or: 'or',
        signUp: 'Sign up',
        learnMore: 'Learn more',
        download: 'Download',
        openApp: 'open the Sephora app to purchase.',
        bopisTooltip: 'Scroll down and tap “Same-Day Delivery” or “Buy Online & Pick Up” to get your beauty today.',
        SDDRougeFreeShip: 'Scroll down and tap “Same-Day Delivery” to try this free benefit as a Rouge member.',
        SDDRougeTestFreeShipping: `Scroll down and tap “Same-Day Delivery” to try this free benefit on $${vars[0]}+ orders as a Rouge member.`,
        viewSimilarProducts: 'View similar products',
        storePickup: 'for Store Pickup',

        standardShipping: 'Get It Shipped',
        sameDayDelivery: 'for Same-Day Delivery',
        fastDelivery: 'for Fast Delivery',
        autoReplenish: `Deliver every ${vars[0]}`,
        sameDayCustomDelivery: `for ${vars[0]}`


    };
    return resources[label];
}
